'use client';

import React, { useEffect, useState } from 'react';
import { Toaster as ReactToaster, Toast, ToastBar, toast } from 'react-hot-toast';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { GWToastOptions } from './helpers/toast';
import ToastMessage from './components/toast-message';

const Toaster = () => {
  const [toastInfo, setToastInfo] = useState<Record<string, any>>({});
  const { toastId = '', visible } = toastInfo;

  useEffect(() => {
    if (!document || !toastId) {
      return;
    }
    const toastParents = Array.from(document.querySelectorAll(`.${toastId}.toastbar-backdrop`));
    toastParents.forEach((parentEl) => {
      const wrapper = parentEl?.parentElement?.parentElement as HTMLElement;
      if (!wrapper) {
        return;
      }
      wrapper.style.background = visible ? `rgba(0, 0, 0, 0.5)` : '';
      wrapper.style.left = visible ? '0px' : '';
      wrapper.style.top = visible ? '0px' : '';
      wrapper.style.right = visible ? '0px' : '';
      wrapper.style.inset = visible ? '0px' : '';
      const wrapSection = wrapper.firstElementChild as HTMLElement;
      if (wrapSection) {
        wrapSection.style.top = visible ? '16px' : '';
      }
    })
  }, [toastId, visible]);

  return (
    <ReactToaster>
      {(t: GWToastOptions) => {
        if (t.toastId && (toastInfo.toastId !== t.toastId || toastInfo.visible !== t.visible)) {
          setToastInfo({ toastId: t.toastId, visible: t.visible });
        }
        return <div
          className={`toastbar-parent h-10 w-full md:w-[400px] ${t.wrapperClassName ? t.wrapperClassName : ''} ${t.toastId ? t.toastId : ''} ${t.showbackdrop ? 'toastbar-backdrop' : ''}`}
          style={{ boxShadow: '-1px 8px 24px 0px rgba(0, 0, 0, 0.15), 0px 4px 4px 0px rgba(0, 0, 0, 0.05);' }}
        >
          <ToastBar
            toast={t as unknown as Toast}
            style={{
              width: '100%',
              height: '100%',
              padding: '12px',
              margin: '0px auto',
            }}
          >
            {({ icon, message }) => (
              <div className="flex w-full items-center justify-between">
                <div className="flex items-center gap-3">
                  <span className="block shrink-0">{icon}</span>
                  <ToastMessage>{message}</ToastMessage>
                </div>
                <XMarkIcon className="h-5 w-5 shrink-0 hover:cursor-pointer" onClick={() => toast.dismiss(t.id)} />
              </div>
            )}
          </ToastBar>
        </div>
      }}
    </ReactToaster>
  );
};

export default Toaster;
